import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

export const useLogClickScrollableIconList = () => {
  const screen = useAtomicScreen();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (logging: AnyObject) => {
      logAnalyticsEvent({
        name: 'CLICK_SCROLLABLE_ICON_LIST',
        analytics: {
          ...logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: logging.ably_only_log,
      });
    },
    [logAnalyticsEvent, screen],
  );
};
